const _version = "2.9.4"
function version() {
    return _version;
}
export default version
